import commonService from 'utils/commonService';
import apiService from 'bff/services/apiService';
import { BaseRes } from 'bff/models/base/baseRes';
import { ImageList } from 'bff/models/surveyVehicle/imageList';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { Codes } from 'bff/models/info';
import { SurveyVehiclePClass } from 'constants/enums/surveyVehiclePClass.enum';
import { SurveyStepInfo, SurveyStepInfoContent } from 'bff/models/surveyVehicle';
import { CodeId } from 'constants/enums/codeId.enum';

/**
 * @description 取得初始化資料
*/
const fetchInitSetting = async (applyNo:string, vehiclePNo:string) => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const imgListReq = commonService.getApiReqData({ APPLY_NO: applyNo, VEHICLE_PNO: vehiclePNo });
  const surveyStepInfoReq = commonService.getApiReqData({ PARENT_PCLASS: SurveyVehiclePClass.CARSURVEYGRP, CHILD_PCLASS: SurveyVehiclePClass.CARSURVEY });

  const result = await Promise.all([
    apiService.fetchImageList(imgListReq, reqConfig),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI, CodeId.W030),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.CARSURVEYDONE),
    apiService.fetchVehicleSurveyStepInfo(surveyStepInfoReq, reqConfig)
  ]).then(([carSurveyImgsRes, UICodeRes, carSurveyDoneCodeRes, surveyStepInfoRes]) => {
    const carSurveyImgsBaseRes:BaseRes<ImageList> = { ...carSurveyImgsRes };
    const UICodeBaseRes:BaseRes<Codes> = { ...UICodeRes };
    const carSurveyDoneCodeBaseRes:BaseRes<Codes> = { ...carSurveyDoneCodeRes };
    const surveyStepInfoBaseRes:BaseRes<SurveyStepInfo> = { ...surveyStepInfoRes };

    const res = {
      carSurveyImgs: [...carSurveyImgsBaseRes.TRANRS.CAR_SURVEY_IMAGE],
      UICodes: commonService.arrayTypeReturn(UICodeBaseRes.TRANRS.CODES),
      carSurveyDoneCodes: commonService.arrayTypeReturn(carSurveyDoneCodeBaseRes.TRANRS.CODES),
      surveyStepInfo: commonService.arrayTypeReturn(surveyStepInfoBaseRes.TRANRS.CARSURVEYGRP)
        .sort((first:SurveyStepInfoContent, second:SurveyStepInfoContent) => {
          if ((first && first.PARAM_ORDER) && (second && second.PARAM_ORDER)) {
            return +first.PARAM_ORDER - +second.PARAM_ORDER;
          }
          return 0;
        })
    };

    return res;
  });

  return result;
};

const imageUpload = async (APPLY_NO: string, VEHICLE_PNO: string, IMAGE_NO: number, IMAGE_B64: string) => {
  const baseReq = commonService.getApiReqData({ APPLY_NO: APPLY_NO, VEHICLE_PNO: VEHICLE_PNO, IMAGE_NO: IMAGE_NO, IMAGE_B64: IMAGE_B64 });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.imageUpload(baseReq, reqConfig).then((res: BaseRes<any>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

const fetchImageList = async (APPLY_NO: string, VEHICLE_PNO: string) => {
  const baseReq = commonService.getApiReqData({ APPLY_NO: APPLY_NO, VEHICLE_PNO: VEHICLE_PNO });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchImageList(baseReq, reqConfig).then((res: BaseRes<ImageList>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 驗證勘車連結UUID
*/
const boCarSurveyValidate = async (uuid:string) => {
  const baseReq = commonService.getApiReqData({ CARSURVEY_UUID: uuid });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.boCarSurveyValidate(baseReq, reqConfig).then((res: BaseRes<ImageList>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    return `${res.MWHEADER.RETURNDESC}<br />(error code : ${res.MWHEADER.RETURNCODE})`;
  } else {
    return res.TRANRS;
  }
};

export default {
  fetchInitSetting,
  boCarSurveyValidate,
  imageUpload,
  fetchImageList
};
